import React, { useState } from 'react';
import './ChangePassword.css';
import { useNavigate } from 'react-router-dom';
import { setForgotPassword } from '../../api/loginAPI';
import { toast } from 'react-toastify';

function ChangePassword() {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: ''
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { password, confirmPassword } = formData;

    if (!password || !confirmPassword) {
      toast.warn('Please fill in both fields');
      return;
    }

    if (password !== confirmPassword) {
      toast.error("Passwords don't match");
      return;
    }

    const token = localStorage.getItem('jwt');
    if (!token) {
      toast.error('Session expired. Please log in again.');
      navigate('/login');
      return;
    }

    setLoading(true);
    const result = await setForgotPassword(token, password, confirmPassword);
    setLoading(false);

    if (result?.success !== false) {
      toast.success('Password changed successfully!');
      navigate('/profile');
    } else {
      toast.error(result.message || 'Password change failed');
    }
  };

  return (
    <>
    <div className="back-button" onClick={() => navigate('/profile')}>
  ← back
</div>
    <div className="page profile-layout">
      <h2 className="profile-title">Change Password</h2>
      <form className="change-password-form" onSubmit={handleSubmit}>
        <label>
          New Password
          <input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            required
          />
        </label>
        <label>
          Confirm Password
          <input
            type="password"
            name="confirmPassword"
            value={formData.confirmPassword}
            onChange={handleChange}
            required
          />
        </label>
        <button className="gradient-btn" type="submit" disabled={loading}>
          {loading ? 'Updating...' : 'Change Password'}
        </button>
      </form>
    </div>
    </>
    
  );
}

export default ChangePassword;
